import styled from 'styled-components';

export const ReviewItem = styled.div`
    display: flex;
    margin: 0.4rem 0;
    align-items: center;

    p:last-child {
        margin-left: 1rem;
        width: 1rem;
    }

    & p {
        font-size: 1em;
        margin-right: 1rem;
    }

    & span {
        font-weight: bold;
    }
`;






